import { DestroyRef, inject, Injectable } from '@angular/core';
import { AuthenticationService } from '@app/core/authentication';
import { distinctUntilChanged } from 'rxjs/operators';
import { map, tap } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { GoogleTagManagerWindow } from '@app/core/google-tag-manager';
import { environment } from '../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class GoogleTagManagerService {
    private readonly destroyRef = inject(DestroyRef);

    constructor(private authService: AuthenticationService) {}

    public init(): void {
        if (!environment.googleTagManagerId) {
            console.warn('Google Tag Manager ID not configured. Skipping initialization.');
            return;
        }

        this.authService.identity$
            .pipe(
                map((user) => user?.id),
                distinctUntilChanged(),
                tap((userId) => {
                    const gtagWindow = window as unknown as GoogleTagManagerWindow;
                    gtagWindow.dataLayer?.push({ user_id: (userId ?? '').toString() });
                }),
                takeUntilDestroyed(this.destroyRef),
            )
            .subscribe();
    }
}
